import { AlertCircle, RotateCw } from "lucide-react"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"

// Échec de chargement d'une liste ou d'un détail : un message et un bouton
// Réessayer, jamais un état vide qui ferait croire qu'il n'y a rien.

export function LoadErrorAlert({
  message,
  onRetry,
  isRetrying,
  dataTest,
  messageDataTest,
}: {
  message: string
  onRetry: () => void
  isRetrying: boolean
  dataTest: string
  /** `data-test` du seul message, quand un test lit son texte exact. */
  messageDataTest?: string
}) {
  return (
    <Alert variant="destructive" data-test={dataTest}>
      <AlertCircle className="h-4 w-4" aria-hidden="true" />
      <AlertDescription className="flex flex-wrap items-center justify-between gap-2">
        <span data-test={messageDataTest}>{message}</span>
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={onRetry}
          disabled={isRetrying}
          data-test={`${dataTest}-retry`}
        >
          <RotateCw className="mr-2 h-4 w-4" aria-hidden="true" />
          Réessayer
        </Button>
      </AlertDescription>
    </Alert>
  )
}
